/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function ShivaModel(props) {
  const { nodes, materials } = useGLTF('/playground/shiva.glb')
  return (
    <group {...props} scale={1.8} position={[0, 3, 0]} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Shiva.geometry}
        material={materials['MIa_000376_ShivaNataraja_64kMesh.001']}
        position={[0, 2.155, 0]}
        rotation={[-1.593, 0, 0]}
        scale={5.774}
      />
    </group>
  )
}

useGLTF.preload('/playground/shiva.glb')
